var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listado-texto',{attrs:{"tipos-lista":_vm.categorias,"obras-por-tipo":_vm.obrasPorCategoria,"definiciones":_vm.categoriasDefinicion}})}
var staticRenderFns = []
export { render, staticRenderFns }